import React, { useState } from "react";

export function LoginPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const isFormValid = email.trim() !== "" && password.trim() !== "";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isFormValid) return;
    // اینجا می‌تونید لاجیک واقعی لاگین اضافه کنید
    alert(`Logged in with ${email}`);
    if (onLogin) onLogin();
  };

  return (
    <div style={stylesLogin.page}>
      <form style={stylesLogin.form} onSubmit={handleSubmit} noValidate>
        <h2 style={stylesLogin.title}>Login to Your Account</h2>

        <input
          type="email"
          placeholder="Email Address"
          style={stylesLogin.input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
          aria-label="Email Address"
        />
        <input
          type="password"
          placeholder="Password"
          style={stylesLogin.input}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
          aria-label="Password"
        />

        <button
          type="submit"
          style={{
            ...stylesLogin.button,
            opacity: isFormValid ? 1 : 0.6,
            cursor: isFormValid ? "pointer" : "not-allowed",
          }}
          disabled={!isFormValid}
        >
          Login
        </button>

        <p style={stylesLogin.text}>
          Don't have an account?{" "}
          <a href="#register" style={stylesLogin.link}>
            Register
          </a>
        </p>
      </form>
    </div>
  );
}

const stylesLogin = {
  page: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #f5a623, #121212)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: "1rem",
  },
  form: {
    backgroundColor: "#222",
    padding: "2.5rem",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "400px",
    boxShadow: "0 0 20px rgba(245,166,35,0.7)",
    color: "#eee",
    display: "flex",
    flexDirection: "column",
    gap: "1.25rem",
    transition: "box-shadow 0.3s",
  },
  title: {
    fontSize: "1.8rem",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "1rem",
    color: "#f5a623",
  },
  input: {
    padding: "0.9rem 1rem",
    borderRadius: "6px",
    border: "1px solid #444",
    fontSize: "1rem",
    backgroundColor: "#333",
    color: "#eee",
    outline: "none",
    transition: "border-color 0.3s",
  },
  button: {
    padding: "0.9rem",
    borderRadius: "6px",
    border: "none",
    backgroundColor: "#f5a623",
    color: "#121212",
    fontWeight: "700",
    fontSize: "1.1rem",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
  text: {
    textAlign: "center",
    fontSize: "0.9rem",
    color: "#ccc",
  },
  link: {
    color: "#f5a623",
    textDecoration: "none",
    fontWeight: "600",
  },
};
